/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth
//LIBS
import sliderHome from "./libs/sliderHome";
import sliderRubric from "./libs/sliderRubric";
import video from "./libs/video";
import menuMain from "./libs/menuMain";
import sliderImage from "./libs/sliderImage";
import sliderMobile from "./libs/sliderMobile";
import accordeon from "./libs/accordeon";
import breadcrumb from "./libs/breadcrumb";
import menuPageInter from "./libs/menuPageInter";
import sliderImageSimple from "./libs/sliderImageSimple";
import sliderTemoignage from "./libs/sliderTemoignage";
import medicament from "./libs/medicament";
import actu from "./libs/actu";
import header from "./libs/header";
import popup from "./libs/popup";
import animScroll from "./libs/animScroll";
import sliderSupport from "./libs/sliderSupport";
import backtop from "./libs/backtop";
import sliderImageLogin from "./libs/sliderImageLogin";
import onglet from "./libs/onglet";
import vuejs from './libs/vuejs/index';
import recaptcha from './libs/recaptcha';
import downloadPdf from './libs/downloadPdf';
import tarteaucitronJs from './libs/tarteaucitronJs';
import paysList from './libs/paysList';
import SVGInject from '@iconfu/svg-inject';
import compil from "./libs/compil";
import offreCommerciale from "./libs/offreCommerciale";

(function (Drupal, $) {

    'use strict';

    // To understand behaviors, see https://drupal.org/node/756722#behaviors
    Drupal.behaviors.arrow = {
        attach: function (context, settings) {
            popup.init();
            recaptcha.init(context);

            // $.datepicker.setDefaults( $.datepicker.regional[ "fr" ] );
            $("input.datepicker").datepicker({
                dateFormat: "dd/mm/yy",
                // altField: "input[data-drupal-selector=edit-field-date-value-min-hidden]",
                // altFormat: "yy-mm-dd"
            });
        }
    };

    Drupal.arrow = {} || Drupal.arrow;
    Drupal.arrow.init = function () {

    };

    $(document).ready(function ($) {
        accordeon.init();
        sliderHome.init();
        sliderRubric.init();
        video.init();
        menuMain.init();
        sliderImage.init();
        breadcrumb.init();
        sliderImageSimple.init();
        sliderTemoignage.init();
        medicament.init();
        actu.init();
        header.init();
        animScroll.init();
        sliderSupport.init();
        backtop.init();
        sliderImageLogin.init();
        sliderMobile.init();
        menuPageInter.init();
        onglet.init();
        tarteaucitronJs.init();
        paysList.init();
        downloadPdf.init();
        compil.init();
        offreCommerciale.init();

        SVGInject(document.querySelectorAll("img.injectable"));

    });
    vuejs.init();
    // We pass the parameters of this anonymous function are the global variables
    // that this script depend on. For example, if the above script requires
    // jQuery, you should change (Drupal) to (Drupal, jQuery) in the line below
    // and, in this file's first line of JS, change function (Drupal) to
    // (Drupal, $)
})(Drupal, jQuery);
